"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("../../../../shared/core");
var StyledContext = styled_components_1.default.div(function (_a) {
    var mediaQueries = _a.theme.mediaQueries;
    return "\n    white-space: nowrap;\n    display: block;\n    ".concat(mediaQueries.smallAndUp, " {\n      display: inline-block;\n    }\n  ");
});
function Context(_a) {
    var contexts = _a.contexts, testID = _a["data-testid"];
    var _b = (0, core_1.useComponents)(), Small = _b.Small, Ul = _b.Ul, Li = _b.Li;
    if (contexts.length === 1) {
        return (react_1.default.createElement(StyledContext, { "data-testid": testID, as: Small }, contexts[0]));
    }
    return (react_1.default.createElement(Ul, null, contexts.map(function (c, index) { return (react_1.default.createElement(Li, { key: index, "data-testid": "".concat(testID, "-").concat(index) },
        react_1.default.createElement(StyledContext, { as: Small }, c))); })));
}
exports.Context = Context;
